export default __webpack_public_path__ + "static/Wizard_01-4d58d0d6b88d929b08703f0709592f77.webp";